<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <section>
    <img src="/static/icon_check_circle.svg" height="80px" alt="OK" />
    <h1 class="mt-15">O pedido foi criado!</h1>
    <p>O usuário receberá um email com um link para efetuar o pagamento.</p>

    <div class="btn-group">
      <router-link
        :to="{ name: 'order', params: { id: order.id } }"
        class="btn bg-green"
        >ir para o pedido</router-link
      >
      <div @click="$emit('clearData')" class="btn bg-purple-outline">
        voltar
      </div>
    </div>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1 {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/OrderCreated.vue